import { ACTION_KEYS, MODULE_KEYS, PAGE_KEYS, REPORT_ENGINE_ROLES } from "./keys";
import type { AppModuleDefinition } from "./types";

export const reportEngineModules: AppModuleDefinition[] = [
  {
    key: MODULE_KEYS.REPORT_ENGINE,
    label: "Report Engine",
    labelKey: "alkokh.sidebar.reportEngine",
    icon: "tabler-chart-histogram",
    fallbackRoles: REPORT_ENGINE_ROLES,
    nav: {
      order: 78,
      titleKey: "alkokh.sidebar.reportEngine",
      icon: "tabler-chart-histogram",
      singlePage: true,
    },
    pages: [
      {
        key: PAGE_KEYS.REPORT_ENGINE,
        label: "Report Engine",
        labelKey: "alkokh.reportEngine.title",
        doctype: "Report",
        paths: ["/report-engine"],
        pathPrefixes: ["/report-engine/"],
        routeNames: ["report-engine", "report-engine-tab"],
        fallbackRoles: REPORT_ENGINE_ROLES,
        nav: {
          titleKey: "alkokh.sidebar.reportEngine",
          icon: "tabler-chart-bar",
          order: 10,
          to: { path: "/report-engine" },
        },
      },
    ],
    actions: [
      {
        key: ACTION_KEYS.REPORT_ENGINE_EXPORT,
        label: "Export reports",
        labelKey: "alkokh.reportEngine.actions.export",
        pageKey: PAGE_KEYS.REPORT_ENGINE,
        fallbackRoles: REPORT_ENGINE_ROLES,
      },
      {
        key: ACTION_KEYS.REPORT_ENGINE_PRINT,
        label: "Print reports",
        labelKey: "alkokh.reportEngine.actions.print",
        pageKey: PAGE_KEYS.REPORT_ENGINE,
        fallbackRoles: REPORT_ENGINE_ROLES,
      },
      {
        key: ACTION_KEYS.REPORT_ENGINE_IMPORT,
        label: "Import records",
        labelKey: "alkokh.reportEngine.actions.import",
        pageKey: PAGE_KEYS.REPORT_ENGINE,
        fallbackRoles: REPORT_ENGINE_ROLES,
      },
    ],
    search: [
      {
        group: "Operations",
        icon: "tabler-chart-histogram",
        title: "Report Engine",
        url: { path: "/report-engine" },
        accessKey: PAGE_KEYS.REPORT_ENGINE,
        order: 30,
      },
    ],
  },
];
